// Tracks which products a customer has looked at, in a browser-local list (no login
// required - works the same for guests and signed-in shoppers). Newest first, capped
// so it can't grow unbounded.
const STORAGE_KEY = 'viverra_recently_viewed';
const MAX_ITEMS = 12;

export const addRecentlyViewed = (productId) => {
  if (!productId) return;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    let ids = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(ids)) ids = [];
    ids = ids.filter((id) => id !== productId);
    ids.unshift(productId);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids.slice(0, MAX_ITEMS)));
  } catch (error) {
    console.error('Failed to save recently viewed product:', error);
  }
};

export const getRecentlyViewedIds = (excludeId) => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const ids = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(ids)) return [];
    return excludeId ? ids.filter((id) => id !== excludeId) : ids;
  } catch {
    return [];
  }
};
